import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { User } from '../../../shared/entities/user';
import { Panic } from '../../../shared/entities/panic';

import { PanicComponent } from '../../components/panic/panic.component';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { Router } from '@angular/router';
import { NotificationAlert } from '../../../shared/entities/notification-alert';
import { NotificationService } from '../../../shared/services/notification.service';
import { ChangePasswordDialogComponent } from '../change-password/change-password.component';
import { MatDialog } from '@angular/material';

declare var require: any;

@Component({
    selector: 'custom-header',
    template: require('./custom-header.component.html'),
   
})

export class CustomHeaderComponent implements OnInit{

    @Output()
    private onClickOpenMenu : EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    private onClickChangePass : EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    private onClickLogout : EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    private onClickShowPanic : EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    private panics:Panic[];

    @Input()
    public menuOpen:boolean;

    ngOnInit(){
        //this.notificationService.getAllNotifications()
    }

    constructor( public authenticationService:AuthenticationService,
                 public notificationService:NotificationService,
                 public dialog:MatDialog ) {}    


    private onClickOpenMenuEvent() {
        //this.authenticationService.isOpenMenuModule = true;
        //console.log('MENU OPEN => ' + this.menuOpen);
        this.onClickOpenMenu.emit(!this.menuOpen);
    }

    private onClickShowChangePassEvent() {
        let dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
            width: '390px', height: '300px',
            data: { user: this.authenticationService.userLogged }
          });
          
          dialogRef.afterClosed().subscribe(result => {
            if ( result ) {
                //this.deleteOrder(this.order);
            } else {
                  //this.authenticationService.isLoading = false;
            }
  
          });
        //this.onClickChangePass.emit();
    }


    private onClickLogoutEvent() {
        this.onClickLogout.emit(true);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/core/components/custom-header/custom-header.component.ts